<template>
  <div>
    <v-client-table
      :data="table.items"
      :columns="table.columns"
      :options="table.options"
      class="table-default"
      :class="{ 'table-default--loading': table_preloader }"
    >
      <template #h__manager><div class="table-default__left">Manager</div></template>
      <template #h__from><div class="table-default__left">From</div></template>
      <template #h__to><div class="table-default__left">To</div></template>
      <template #date="{ row }">{{ formatDateTime(row.timestamp) }}</template>
      <template #from="{ row }">
        <div class="table-default__left">
          <span class="status-tag" :style="{ 'backgroundColor': row.current.color }">{{ row.current.name }}</span>
        </div>
      </template>
      <template #to="{ row }">
        <div class="table-default__left">
          <span class="status-tag" :style="{ 'backgroundColor': row.new.color }">{{ row.new.name }}</span>
        </div>
      </template>
      <template #manager="{ row }">
        <div class="table-default__left table-default__left--photo">
          <template v-if="row.manager">
            <div class="table-default__photo">
              <img :src="getUserAvatar(row.manager.crop.crop_url)" alt="Avatar">
            </div>
            <span>{{ row.manager.full_name }}</span>
          </template>
          <span v-else>System</span>
        </div>
      </template>
    </v-client-table>
    <app-cells position="between">
      <div>
        <paginate
          :clickHandler="onClickPagination"
          v-if="pagination.pages > 1"
          v-model="pagination.page"
          :page-count="pagination.pages"
          :prev-text="'<'"
          :next-text="'>'"
          :container-class="'pagination'"
          :page-class="'pagination__item'"
          :page-link-class="'pagination__link'"
          :prev-class="'pagination__item pagination__item--prev'"
          :next-class="'pagination__item pagination__item--next'"
          :next-link-class="'pagination__link pagination__link--next'"
          :prev-link-class="'pagination__link pagination__link--prev'"
        />
      </div>
      <app-table-records :all="pagination.count" :count="table.items.length" :page="pagination.page" />
    </app-cells>
  </div>
</template>

<script>
import { getLeadStatusLogs } from '@/http'
import { format, parseISO } from 'date-fns'
export default {
  name: 'LeadsDetailStatus',
  data() {
    return {
      table: {
        items: [],
        columns: [
          'date',
          'from',
          'to',
          'manager',
        ],
        options: {
          headings: {
            date: 'Date',
            from: 'From',
            to: 'To',
            manager: 'Manager',
          },
          pagination: {show: false},
          sortable: [],
          perPage: 20,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      pagination: {
        pages: 1,
        page: 1,
        count: 1,
      },
      table_preloader: false,
    }
  },
  created() {
    this.fetchItems()
  },
  methods: {
    fetchItems() {
      getLeadStatusLogs(this.$route.params.id, {page: this.pagination.page, page_size: 20})
        .then(response => {
          this.table.items = response.data.results
          this.pagination.pages = response.data.pages
          this.pagination.count = response.data.count
          this.table_preloader = false
        })
    },
    onClickPagination(page) {
      this.table_preloader = true
      this.pagination.page = page
      this.fetchItems()
    },
    getUserAvatar(crop_url) {
      if (crop_url) return crop_url
      return require('@/assets/img/temp/avatar-slug.jpg')
    },
    formatDateTime(date) {
      if (!date) return '-'
      return format(parseISO(date), 'dd MMMM yyyy HH:mm')
    },
  }
}
</script>
